export const isGamingPlatformAccountSet = (userSession, platform) => {
  if (userSession && userSession.user && userSession.user.accounts.findIndex(acc => acc.platform === platform) !== -1)
    return true;
  return false;
};
